/**
 * Routes accessibles en mode "Tous départements" (isAllMode).
 *
 * Source de vérité unique consommée par :
 *   - DrawerMenu  : grise les liens incompatibles
 *   - DeptRequiredRoute : affiche une alerte "Choisir un dept" sur les autres
 *
 * Ajouter une route ici = la rendre accessible sans dept sélectionné.
 * Implique que la page sait fonctionner sans `selectedDepartement` (pas de
 * write, ou le Form fournit un dept explicite).
 */
export const MULTI_DEPT_ROUTES: readonly string[] = [
  '/',
  // Dashboard (anciennement à `/`, désormais occupé par la page d'accueil `Home`).
  '/dashboard',
  '/StockAndStat',
  '/article',
  '/comptes',
  '/immobilisation',
  // Paramètres génériques : en mode ALL on gère les types GLOBAL (familles,
  // règlements…), en mode dept les types DEPARTEMENT (caisse, dépôt) → accessible
  // dans les deux modes. La page force la portée à l'écriture (pas de dept requis).
  '/parametre_generique',
  // Documents de vente : la création affiche désormais un sélecteur de département
  // obligatoire quand aucun contexte n'est actif (DocumentVenteForm) — l'édition
  // préserve toujours le departement_id existant du document.
  '/facturation',
  // Règlements (caisse) : même traitement — sélecteur obligatoire à la création
  // en mode Tous (ReglementForm), édition inchangée.
  '/caisse',
  // Opérations diverses / Transfert : sélecteur déjà correct à la création
  // (OperationDiverseForm/TransfertForm) — il ne manquait que l'accès à la page.
  '/operationsDiverses',
] as const;

export const isMultiDeptRoute = (path: string): boolean =>
  MULTI_DEPT_ROUTES.some(r => path === r || path.startsWith(r + '/'));
